export const changeAverageClimateDataReducer = (state = {}, action) => {
  switch (action.type) {
    case "CHANGE_AVERAGE_CLIMATE_DATA":
      return action.payload.averageClimateData;
    default:
      return state;
  }
};
